module.exports = __webpack_public_path__ + "school/img/xinwen.676d7e34.jpg";